<template>
  <div class="folder-icon-box">
    <i :class="{ 'UXicon-folder_minus': isOpen && item.type !== 'small',
          'UXicon-folder_plus' : !isOpen && item.type !== 'small',
          'UXicon-folder' : (item.type === 'small' || isFolder === 0) }"
       @click="() => { toggle(item) }"></i>
  </div>
</template>

<script>
export default {
  name: 'folderIcon',
  props: {
    item: Object
  },
  computed: {
    isFolder () {
      return this.item.hasOwnProperty('children') &&
        this.item.children.filter(child => !child.isRemove).length
    },
    isOpen () {
      return this.item.isOpen
    }
  },
  methods: {
    toggle (item) {
      if (this.isFolder > 0) {
        this.$eventBus.$emit('change-is-open-item', item.id, item.type)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.folder-icon-box {
  display: flex;
  align-items: center;
  color: #919191;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/agent/components/folderIcon.vue